// extracted by mini-css-extract-plugin
export default {"settingsItem":"index_settingsItem__rBst0","label":"index_label__xP9PA","valueContainer":"index_valueContainer__s9CdD"};